export const PUZZLE_COMMENT_ID_PARAM = "commentId" as const;

/**
 * Reads the puzzle scoreboard comment focus id from a location search string.
 */
export function readPuzzleFocusCommentIdFromSearch(search: string): string | null {
    const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
    const raw = params.get(PUZZLE_COMMENT_ID_PARAM);
    const trimmed = raw?.trim() ?? "";
    return trimmed.length > 0 ? trimmed : null;
}

/**
 * Removes the comment focus param so refresh does not re-scroll to the same comment.
 */
export function stripPuzzleCommentIdFromSearch(search: string): string {
    const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
    params.delete(PUZZLE_COMMENT_ID_PARAM);
    const serialized = params.toString();
    return serialized ? `?${serialized}` : "";
}
